package com.eladfinish.bible.contest.common.usecases

sealed interface VersePickTarget {
    data object Random : VersePickTarget

    /**
     * 1-based verse number, e.g. 1 = verse א, 2 = verse ב
     */
    data class Nth(
        val verseNumber: Int,
    ) : VersePickTarget
}
